const packageName = 'appLovin';

const t = [
    'https://s.axon.ai/pixel.js',
    'https://c.albss.com/p/l/loader.iife.js',
];
const snippet = (axonEventKey) => {
    if (!window || !document || window.axon) {
        return;
    }
    if (!window.axon) {
        const a = (window.axon = function (...args) {
            a.performOperation
                ? // eslint-disable-next-line prefer-spread,prefer-rest-params
                    a.performOperation.apply(a, args)
                : // eslint-disable-next-line prefer-rest-params
                    a.operationQueue.push(arguments);
        });
        a.operationQueue = [];
        a.ts = Date.now();
        a.eventKey = axonEventKey;
        let o = 0;
        for (const script = document.getElementsByTagName('script')[0]; o < t.length; o++) {
            const i = document.createElement('script');
            i.async = !0;
            i.src = t[o];
            if (script && script.parentNode) {
                script.parentNode.insertBefore(i, script);
            }
        }
    }
};
const init = ({ manifest }) => {
    if (!manifest.variables ||
        !manifest.variables['eventKey'] ||
        manifest.variables['enableBrowser'] !== '1') {
        return;
    }
    snippet(manifest.variables['eventKey']);
    if (!window.axon) {
        return;
    }
    window['axon']('init');
};

const canLog = () => {
    try {
        return localStorage.getItem('edgeTagDebug') === '1';
    }
    catch {
        return false;
    }
};
const prefix = `[EdgeTag]`;
const logger = {
    log: (...args) => {
        if (canLog()) {
            console.log(prefix, ...args);
        }
    },
    error: (...args) => {
        if (canLog()) {
            console.error(prefix, ...args);
        }
    },
    info: (...args) => {
        if (canLog()) {
            console.info(prefix, ...args);
        }
    },
    trace: (...args) => {
        if (canLog()) {
            console.trace(prefix, ...args);
        }
    },
};

const getParsedCategoryId = (category) => {
    try {
        const parsed = JSON.parse(category);
        return parsed.value;
    }
    catch (error) {
        logger.error(`Error parsing category: ${category}`, error);
        return undefined;
    }
};
const getCategories = (categoryMapping) => {
    let categoryMappings = [];
    try {
        categoryMappings = JSON.parse(categoryMapping || '[]');
    }
    catch {
        logger.error('Unable to parse category mappings');
        categoryMappings = [];
    }
    return new Map(categoryMappings.map(({ storeCategory, appLovinCategory }) => [
        storeCategory.toLowerCase(),
        appLovinCategory.value,
    ]));
};
const getItems = (contents, defaultCategoryId, categories) => contents.map((item) => {
    let categoryId = '';
    if (item.category) {
        categoryId = categories.get(item.category.toLowerCase()) || '';
    }
    return {
        item_id: item.id,
        item_name: item.title || '',
        price: item.item_price,
        quantity: item.quantity,
        image_url: item.image,
        item_variant_id: item.variantId,
        item_brand: item.brand,
        item_category_id: categoryId || defaultCategoryId || '',
    };
});
const getEventData = ({ eventName, userId, data, defaultCategory, categoryMapping, }) => {
    const categories = getCategories(categoryMapping);
    const defaultCategoryId = getParsedCategoryId(defaultCategory);
    switch (eventName) {
        case 'AddToCart': {
            return {
                name: 'add_to_cart',
                data: {
                    currency: data.currency,
                    items: data.contents
                        ? getItems(data.contents, defaultCategoryId, categories)
                        : [],
                    value: data.value,
                },
            };
        }
        case 'InitiateCheckout': {
            return {
                name: 'begin_checkout',
                data: {
                    currency: data.currency,
                    items: data.contents
                        ? getItems(data.contents, defaultCategoryId, categories)
                        : [],
                    value: data.value,
                },
            };
        }
        case 'Lead': {
            return {
                name: 'generate_lead',
                data: {
                    currency: data.currency,
                    user_id: userId,
                    value: data.value,
                },
            };
        }
        case 'PageView': {
            return {
                name: 'page_view',
                data: {},
            };
        }
        case 'Purchase': {
            return {
                name: 'purchase',
                data: {
                    currency: data.currency,
                    items: data.contents
                        ? getItems(data.contents, defaultCategoryId, categories)
                        : [],
                    transaction_id: data.orderId,
                    user_id: userId,
                    value: data.value,
                },
            };
        }
        case 'RemoveFromCart': {
            return {
                name: 'remove_from_cart',
                data: {
                    currency: data.currency,
                    items: data.contents
                        ? getItems(data.contents, defaultCategoryId, categories)
                        : [],
                    value: data.value,
                },
            };
        }
        case 'Search': {
            return {
                name: 'search',
                data: {
                    search_term: data.search,
                },
            };
        }
        case 'CompleteRegistration': {
            return {
                name: 'sign_up',
                data: {
                    user_id: userId,
                },
            };
        }
        case 'ViewContent': {
            return {
                name: 'view_item',
                data: {
                    currency: data.currency,
                    items: data.contents
                        ? getItems(data.contents, defaultCategoryId, categories)
                        : [],
                    value: data.value,
                },
            };
        }
        case 'Subscribe': {
            return {
                name: 'subscribe',
                data: {
                    currency: data.currency,
                    value: data.value,
                    user_id: userId,
                },
            };
        }
    }
};

const tag = ({ data, eventName, manifestVariables, userId }) => {
    const payload = {
        sdkVersion: "1.17.0" ,
    };
    if (window.axon && manifestVariables['enableBrowser'] === '1') {
        try {
            const defaultCategory = manifestVariables['defaultCategory'];
            const categoryMapping = manifestVariables['categoryMapping'];
            const event = getEventData({
                eventName,
                userId,
                data,
                defaultCategory,
                categoryMapping,
            });
            if (!event) {
                logger.log(`[${packageName}] ${eventName} not supported`);
                return;
            }
            window.axon('track', event.name, event.data);
        }
        catch (e) {
            logger.error(e);
        }
    }
    return payload;
};

// eslint-disable-next-line @nx/enforce-module-boundaries
const data = {
    name: packageName,
    tag,
    init,
};
try {
    if (window) {
        if (!window.edgetagProviders) {
            window.edgetagProviders = [];
        }
        window.edgetagProviders.push(data);
    }
}
catch {
    // No window
}

export { data as default };
